/* eslint-disable */
// source: vivacity/core/anpr_journey.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var vivacity_core_trigger_zone_crossing_pb = require('../../vivacity/core/trigger_zone_crossing_pb.js');
goog.object.extend(proto, vivacity_core_trigger_zone_crossing_pb);
var vivacity_core_countline_crossing_pb = require('../../vivacity/core/countline_crossing_pb.js');
goog.object.extend(proto, vivacity_core_countline_crossing_pb);
var vivacity_core_tracing_context_pb = require('../../vivacity/core/tracing_context_pb.js');
goog.object.extend(proto, vivacity_core_tracing_context_pb);
goog.exportSymbol('proto.vivacity.core.AnprJourney', null, global);
goog.exportSymbol('proto.vivacity.core.AnprJourney.CrossingEvent', null, global);
goog.exportSymbol('proto.vivacity.core.AnprJourney.CrossingEvent.CrossingType', null, global);
goog.exportSymbol('proto.vivacity.core.AnprJourney.PlateMatchMetrics', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vivacity.core.AnprJourney = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vivacity.core.AnprJourney.repeatedFields_, null);
};
goog.inherits(proto.vivacity.core.AnprJourney, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vivacity.core.AnprJourney.displayName = 'proto.vivacity.core.AnprJourney';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vivacity.core.AnprJourney.CrossingEvent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vivacity.core.AnprJourney.CrossingEvent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vivacity.core.AnprJourney.CrossingEvent.displayName = 'proto.vivacity.core.AnprJourney.CrossingEvent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vivacity.core.AnprJourney.PlateMatchMetrics = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vivacity.core.AnprJourney.PlateMatchMetrics, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vivacity.core.AnprJourney.PlateMatchMetrics.displayName = 'proto.vivacity.core.AnprJourney.PlateMatchMetrics';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vivacity.core.AnprJourney.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vivacity.core.AnprJourney.prototype.toObject = function(opt_includeInstance) {
  return proto.vivacity.core.AnprJourney.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vivacity.core.AnprJourney} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.core.AnprJourney.toObject = function(includeInstance, msg) {
  var f, obj = {
    originMessage: (f = msg.getOriginMessage()) && proto.vivacity.core.AnprJourney.CrossingEvent.toObject(includeInstance, f),
    destinationMessage: (f = msg.getDestinationMessage()) && proto.vivacity.core.AnprJourney.CrossingEvent.toObject(includeInstance, f),
    plateMatchesList: jspb.Message.toObjectList(msg.getPlateMatchesList(),
    proto.vivacity.core.AnprJourney.PlateMatchMetrics.toObject, includeInstance),
    intersectionOverUnion: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
    tracingCtx: (f = msg.getTracingCtx()) && vivacity_core_tracing_context_pb.TracingContext.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vivacity.core.AnprJourney}
 */
proto.vivacity.core.AnprJourney.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vivacity.core.AnprJourney;
  return proto.vivacity.core.AnprJourney.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vivacity.core.AnprJourney} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vivacity.core.AnprJourney}
 */
proto.vivacity.core.AnprJourney.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = new proto.vivacity.core.AnprJourney.CrossingEvent;
      reader.readMessage(value,proto.vivacity.core.AnprJourney.CrossingEvent.deserializeBinaryFromReader);
      msg.setOriginMessage(value);
      break;
    case 3:
      var value = new proto.vivacity.core.AnprJourney.CrossingEvent;
      reader.readMessage(value,proto.vivacity.core.AnprJourney.CrossingEvent.deserializeBinaryFromReader);
      msg.setDestinationMessage(value);
      break;
    case 4:
      var value = new proto.vivacity.core.AnprJourney.PlateMatchMetrics;
      reader.readMessage(value,proto.vivacity.core.AnprJourney.PlateMatchMetrics.deserializeBinaryFromReader);
      msg.addPlateMatches(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setIntersectionOverUnion(value);
      break;
    case 6:
      var value = new vivacity_core_tracing_context_pb.TracingContext;
      reader.readMessage(value,vivacity_core_tracing_context_pb.TracingContext.deserializeBinaryFromReader);
      msg.setTracingCtx(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vivacity.core.AnprJourney.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vivacity.core.AnprJourney.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vivacity.core.AnprJourney} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.core.AnprJourney.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOriginMessage();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.vivacity.core.AnprJourney.CrossingEvent.serializeBinaryToWriter
    );
  }
  f = message.getDestinationMessage();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.vivacity.core.AnprJourney.CrossingEvent.serializeBinaryToWriter
    );
  }
  f = message.getPlateMatchesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.vivacity.core.AnprJourney.PlateMatchMetrics.serializeBinaryToWriter
    );
  }
  f = message.getIntersectionOverUnion();
  if (f !== 0.0) {
    writer.writeFloat(
      5,
      f
    );
  }
  f = message.getTracingCtx();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      vivacity_core_tracing_context_pb.TracingContext.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vivacity.core.AnprJourney.CrossingEvent.prototype.toObject = function(opt_includeInstance) {
  return proto.vivacity.core.AnprJourney.CrossingEvent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vivacity.core.AnprJourney.CrossingEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.core.AnprJourney.CrossingEvent.toObject = function(includeInstance, msg) {
  var f, obj = {
    zoneCrossing: (f = msg.getZoneCrossing()) && vivacity_core_trigger_zone_crossing_pb.TriggerZoneCrossing.toObject(includeInstance, f),
    countlineCrossing: (f = msg.getCountlineCrossing()) && vivacity_core_countline_crossing_pb.CountlineCrossing.toObject(includeInstance, f),
    crossingType: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vivacity.core.AnprJourney.CrossingEvent}
 */
proto.vivacity.core.AnprJourney.CrossingEvent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vivacity.core.AnprJourney.CrossingEvent;
  return proto.vivacity.core.AnprJourney.CrossingEvent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vivacity.core.AnprJourney.CrossingEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vivacity.core.AnprJourney.CrossingEvent}
 */
proto.vivacity.core.AnprJourney.CrossingEvent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new vivacity_core_trigger_zone_crossing_pb.TriggerZoneCrossing;
      reader.readMessage(value,vivacity_core_trigger_zone_crossing_pb.TriggerZoneCrossing.deserializeBinaryFromReader);
      msg.setZoneCrossing(value);
      break;
    case 2:
      var value = new vivacity_core_countline_crossing_pb.CountlineCrossing;
      reader.readMessage(value,vivacity_core_countline_crossing_pb.CountlineCrossing.deserializeBinaryFromReader);
      msg.setCountlineCrossing(value);
      break;
    case 3:
      var value = /** @type {!proto.vivacity.core.AnprJourney.CrossingEvent.CrossingType} */ (reader.readEnum());
      msg.setCrossingType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vivacity.core.AnprJourney.CrossingEvent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vivacity.core.AnprJourney.CrossingEvent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vivacity.core.AnprJourney.CrossingEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.core.AnprJourney.CrossingEvent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getZoneCrossing();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      vivacity_core_trigger_zone_crossing_pb.TriggerZoneCrossing.serializeBinaryToWriter
    );
  }
  f = message.getCountlineCrossing();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      vivacity_core_countline_crossing_pb.CountlineCrossing.serializeBinaryToWriter
    );
  }
  f = message.getCrossingType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.vivacity.core.AnprJourney.CrossingEvent.CrossingType = {
  UNKNOWN: 0,
  ZONE_CROSSING: 1,
  COUNTLINE_CROSSING: 2
};

/**
 * optional TriggerZoneCrossing zone_crossing = 1;
 * @return {?proto.vivacity.core.TriggerZoneCrossing}
 */
proto.vivacity.core.AnprJourney.CrossingEvent.prototype.getZoneCrossing = function() {
  return /** @type{?proto.vivacity.core.TriggerZoneCrossing} */ (
    jspb.Message.getWrapperField(this, vivacity_core_trigger_zone_crossing_pb.TriggerZoneCrossing, 1));
};


/**
 * @param {?proto.vivacity.core.TriggerZoneCrossing|undefined} value
 * @return {!proto.vivacity.core.AnprJourney.CrossingEvent} returns this
*/
proto.vivacity.core.AnprJourney.CrossingEvent.prototype.setZoneCrossing = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vivacity.core.AnprJourney.CrossingEvent} returns this
 */
proto.vivacity.core.AnprJourney.CrossingEvent.prototype.clearZoneCrossing = function() {
  return this.setZoneCrossing(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vivacity.core.AnprJourney.CrossingEvent.prototype.hasZoneCrossing = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional CountlineCrossing countline_crossing = 2;
 * @return {?proto.vivacity.core.CountlineCrossing}
 */
proto.vivacity.core.AnprJourney.CrossingEvent.prototype.getCountlineCrossing = function() {
  return /** @type{?proto.vivacity.core.CountlineCrossing} */ (
    jspb.Message.getWrapperField(this, vivacity_core_countline_crossing_pb.CountlineCrossing, 2));
};


/**
 * @param {?proto.vivacity.core.CountlineCrossing|undefined} value
 * @return {!proto.vivacity.core.AnprJourney.CrossingEvent} returns this
*/
proto.vivacity.core.AnprJourney.CrossingEvent.prototype.setCountlineCrossing = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vivacity.core.AnprJourney.CrossingEvent} returns this
 */
proto.vivacity.core.AnprJourney.CrossingEvent.prototype.clearCountlineCrossing = function() {
  return this.setCountlineCrossing(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vivacity.core.AnprJourney.CrossingEvent.prototype.hasCountlineCrossing = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional CrossingType crossing_type = 3;
 * @return {!proto.vivacity.core.AnprJourney.CrossingEvent.CrossingType}
 */
proto.vivacity.core.AnprJourney.CrossingEvent.prototype.getCrossingType = function() {
  return /** @type {!proto.vivacity.core.AnprJourney.CrossingEvent.CrossingType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.vivacity.core.AnprJourney.CrossingEvent.CrossingType} value
 * @return {!proto.vivacity.core.AnprJourney.CrossingEvent} returns this
 */
proto.vivacity.core.AnprJourney.CrossingEvent.prototype.setCrossingType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vivacity.core.AnprJourney.PlateMatchMetrics.prototype.toObject = function(opt_includeInstance) {
  return proto.vivacity.core.AnprJourney.PlateMatchMetrics.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vivacity.core.AnprJourney.PlateMatchMetrics} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.core.AnprJourney.PlateMatchMetrics.toObject = function(includeInstance, msg) {
  var f, obj = {
    plateHash: jspb.Message.getFieldWithDefault(msg, 1, ""),
    journeyConfidence: jspb.Message.getFieldWithDefault(msg, 2, 0),
    journeyConfidenceJointRank: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vivacity.core.AnprJourney.PlateMatchMetrics}
 */
proto.vivacity.core.AnprJourney.PlateMatchMetrics.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vivacity.core.AnprJourney.PlateMatchMetrics;
  return proto.vivacity.core.AnprJourney.PlateMatchMetrics.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vivacity.core.AnprJourney.PlateMatchMetrics} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vivacity.core.AnprJourney.PlateMatchMetrics}
 */
proto.vivacity.core.AnprJourney.PlateMatchMetrics.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlateHash(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setJourneyConfidence(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setJourneyConfidenceJointRank(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vivacity.core.AnprJourney.PlateMatchMetrics.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vivacity.core.AnprJourney.PlateMatchMetrics.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vivacity.core.AnprJourney.PlateMatchMetrics} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.core.AnprJourney.PlateMatchMetrics.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlateHash();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getJourneyConfidence();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getJourneyConfidenceJointRank();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string plate_hash = 1;
 * @return {string}
 */
proto.vivacity.core.AnprJourney.PlateMatchMetrics.prototype.getPlateHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.vivacity.core.AnprJourney.PlateMatchMetrics} returns this
 */
proto.vivacity.core.AnprJourney.PlateMatchMetrics.prototype.setPlateHash = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 journey_confidence = 2;
 * @return {number}
 */
proto.vivacity.core.AnprJourney.PlateMatchMetrics.prototype.getJourneyConfidence = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.AnprJourney.PlateMatchMetrics} returns this
 */
proto.vivacity.core.AnprJourney.PlateMatchMetrics.prototype.setJourneyConfidence = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 journey_confidence_joint_rank = 3;
 * @return {number}
 */
proto.vivacity.core.AnprJourney.PlateMatchMetrics.prototype.getJourneyConfidenceJointRank = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.AnprJourney.PlateMatchMetrics} returns this
 */
proto.vivacity.core.AnprJourney.PlateMatchMetrics.prototype.setJourneyConfidenceJointRank = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional CrossingEvent origin_message = 2;
 * @return {?proto.vivacity.core.AnprJourney.CrossingEvent}
 */
proto.vivacity.core.AnprJourney.prototype.getOriginMessage = function() {
  return /** @type{?proto.vivacity.core.AnprJourney.CrossingEvent} */ (
    jspb.Message.getWrapperField(this, proto.vivacity.core.AnprJourney.CrossingEvent, 2));
};


/**
 * @param {?proto.vivacity.core.AnprJourney.CrossingEvent|undefined} value
 * @return {!proto.vivacity.core.AnprJourney} returns this
*/
proto.vivacity.core.AnprJourney.prototype.setOriginMessage = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vivacity.core.AnprJourney} returns this
 */
proto.vivacity.core.AnprJourney.prototype.clearOriginMessage = function() {
  return this.setOriginMessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vivacity.core.AnprJourney.prototype.hasOriginMessage = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional CrossingEvent destination_message = 3;
 * @return {?proto.vivacity.core.AnprJourney.CrossingEvent}
 */
proto.vivacity.core.AnprJourney.prototype.getDestinationMessage = function() {
  return /** @type{?proto.vivacity.core.AnprJourney.CrossingEvent} */ (
    jspb.Message.getWrapperField(this, proto.vivacity.core.AnprJourney.CrossingEvent, 3));
};


/**
 * @param {?proto.vivacity.core.AnprJourney.CrossingEvent|undefined} value
 * @return {!proto.vivacity.core.AnprJourney} returns this
*/
proto.vivacity.core.AnprJourney.prototype.setDestinationMessage = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vivacity.core.AnprJourney} returns this
 */
proto.vivacity.core.AnprJourney.prototype.clearDestinationMessage = function() {
  return this.setDestinationMessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vivacity.core.AnprJourney.prototype.hasDestinationMessage = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated PlateMatchMetrics plate_matches = 4;
 * @return {!Array<!proto.vivacity.core.AnprJourney.PlateMatchMetrics>}
 */
proto.vivacity.core.AnprJourney.prototype.getPlateMatchesList = function() {
  return /** @type{!Array<!proto.vivacity.core.AnprJourney.PlateMatchMetrics>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.vivacity.core.AnprJourney.PlateMatchMetrics, 4));
};


/**
 * @param {!Array<!proto.vivacity.core.AnprJourney.PlateMatchMetrics>} value
 * @return {!proto.vivacity.core.AnprJourney} returns this
*/
proto.vivacity.core.AnprJourney.prototype.setPlateMatchesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.vivacity.core.AnprJourney.PlateMatchMetrics=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vivacity.core.AnprJourney.PlateMatchMetrics}
 */
proto.vivacity.core.AnprJourney.prototype.addPlateMatches = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.vivacity.core.AnprJourney.PlateMatchMetrics, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vivacity.core.AnprJourney} returns this
 */
proto.vivacity.core.AnprJourney.prototype.clearPlateMatchesList = function() {
  return this.setPlateMatchesList([]);
};


/**
 * optional float intersection_over_union = 5;
 * @return {number}
 */
proto.vivacity.core.AnprJourney.prototype.getIntersectionOverUnion = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.AnprJourney} returns this
 */
proto.vivacity.core.AnprJourney.prototype.setIntersectionOverUnion = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional TracingContext tracing_ctx = 6;
 * @return {?proto.vivacity.core.TracingContext}
 */
proto.vivacity.core.AnprJourney.prototype.getTracingCtx = function() {
  return /** @type{?proto.vivacity.core.TracingContext} */ (
    jspb.Message.getWrapperField(this, vivacity_core_tracing_context_pb.TracingContext, 6));
};


/**
 * @param {?proto.vivacity.core.TracingContext|undefined} value
 * @return {!proto.vivacity.core.AnprJourney} returns this
*/
proto.vivacity.core.AnprJourney.prototype.setTracingCtx = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vivacity.core.AnprJourney} returns this
 */
proto.vivacity.core.AnprJourney.prototype.clearTracingCtx = function() {
  return this.setTracingCtx(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vivacity.core.AnprJourney.prototype.hasTracingCtx = function() {
  return jspb.Message.getField(this, 6) != null;
};


goog.object.extend(exports, proto.vivacity.core);
